import { useRouter } from 'next/router'
import React from 'react'
import CardsRow from '../../components/CardsRow'
import Inspirations from '../../components/Feed'

export const HashtagPage = () => {
  const { hashtag } = useRouter().query

  return (
    <>
      <CardsRow />
      <Inspirations
        version="v3"
        id="search"
        title={hashtag ? `#${hashtag}` : null}
        filters={{ hashtags: [hashtag], kinds: ['featured'] }}
        showTitle={true}
      />
    </>
  )
}
